import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header mb-3" }
const _hoisted_5 = { class: "modal-title w-100 text-center fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "px-3 py-4 text-center" }
const _hoisted_8 = { class: "d-flex align-items-center justify-content-center pb-3" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { DELETE_CONFIRM_MODAL_ID } from '@/views/community-admin/community-site/constants'
import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  article: {
    type: Object as PropType<{ title: string; id: number }>,
  },
  handleDelete: {
    type: Function as PropType<(id: number) => Promise<void> | void | undefined>,
  },
  onSubmit: {
    type: Boolean,
  },
},
  setup(__props) {

const props = __props



const onDeleteClick = () => {
  if (props.handleDelete) {
    props.handleDelete(props.article?.id ?? 0)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: _unref(DELETE_CONFIRM_MODAL_ID),
    tabindex: "-1",
    "aria-labelledby": _unref(DELETE_CONFIRM_MODAL_ID),
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('CK16DeleteArticle')), 1),
          _hoisted_6
        ]),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(translate)('CK16DeleteArticleConfirmMessage').replace('%s', __props.article?.title ?? '')), 1),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(Button, {
            title: _unref(translate)('cancel'),
            class: "m-w-unset me-2",
            type: 'secondary',
            "data-bs-dismiss": "modal"
          }, null, 8, ["title"]),
          _createVNode(Button, {
            onClick: onDeleteClick,
            title: _unref(translate)('deleteButton'),
            class: "m-w-unset",
            type: 'secondary',
            disabled: __props.onSubmit
          }, null, 8, ["title", "disabled"])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})